import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";

const json = {
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P5-E1",
    audio: "Audios/bt_fpt_ai/p14_e1.mp3",
    autoPlay: true,
    isTuLuan:true,
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page14/Key/E1answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    textareaStyle: { width: 800, paddingTop: "5px" },
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "hướng dẫn",
        description: `<span>
        Em gõ chữ vào chỗ chấm để viết đoạn văn nêu lí do yêu thích một câu chuyện đã đọc hoặc đã nghe dựa vào các ý đã tìm được ở ba phần: mở đầu, triển khai, kết thúc.
        <div><video src="Audios/bt_fpt_ai/guide/p14_e1.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    // newWords: [
    //   {
    //     title: "Tra cứu",
    //     description: `
        
    //     <p>
    //      Nội dung tra cứu đang cập nhật..........
    //     </p>
        
    //     `,
    //   },
    // ],
    titleQuestion: [
      {
        num: "",
        title: `
        <div style='margin-left:192px;font-size:30px;color:rgb(102 96 132)'>VIẾT ĐOẠN VĂN NÊU Ý KIẾN</div>
				`,
        color: "rgb(29,193,215)",
      },
    ],

    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
            <div style='width:20cm;border: 5px solid rgb(29,193,215); background-color: rgb(230,249,253); padding:5px 10px;border-radius:20px;box-shadow:0px 2px 3px 4px gray'>
              <b>Đề bài:</b> Viết đoạn văn nêu lý do yêu thích một câu chuyện đã đọc hoặc đã nghe. <br>
              
            </div>   
          <div style='width:20cm;margin:20px 0px'>
          <div>
              <b style='color:rgb(3, 103, 181)'>1.</b>&ensp;<b>Dựa vào các ý đã tìm ở trang 13, viết đoạn văn theo yêu cầu đề bài.</b>
            </div>
            <textarea id='0' rows='10'></textarea>
            <br>
            </div>
        `,
        answer: [""],
      },
    ],
  },
};

export default json;
